import { createStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    menuItem: {
      '&:hover': {
        backgroundColor: '#CACAFC33',
        color: '#3C419A',
      },
    },
    modal: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalTitle: {
      marginTop: '26px',
      marginLeft: '31px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 18,
      lineHeight: '21px',
      color: '#2C2D3E',
      marginBottom: '28px',
    },
    accTypeInput: {
      padding: '0px',
      width: '348px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '59px',
      marginRight: '59px',
      marginBottom: '15px',
      marginTop: '5px',
      appearance: 'none',
    },
    commiteeInput: {
      padding: '0px',
      width: '348px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '59px',
      marginRight: '59px',
      marginBottom: '25px',
      marginTop: '5px',
      appearance: 'none',
    },
    dateInput: {
      padding: '0px',
      width: '348px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '59px',
      marginRight: '59px',
      marginTop: '0px',
      appearance: 'none',
      marginBottom: '40px',
    },
    cancelButton: {
      position: 'relative',
      left: '59px',
      marginBottom: '35px',
      width: '143px',
      height: '36px',
    },
    addUserButton: {
      top: '40px',
      marginLeft: '45px',
      width: '195px',
      height: '35px',
    },
    nextButton: {
      position: 'relative',
      right: '59px',
      marginBottom: '35px',
      width: '143px',
      height: '36px',
    },
    stageInfo: {
      marginTop: '10px',
    },
    selected: {
      color: '#2C2D3ECC',
    },
  }),
);

export const styles = () =>
  createStyles({
    root: {
      width: '466px',
      margin: 0,
      padding: 0,
    },
  });
